<template>
  <v-layout class="login" align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-6">
        <v-toolbar dark :color="toolbarColor" class="darken-1" extended :height="64">
          <div class="login__container">
            <img src="@/assets/logo.png" class="login__img">
          </div>
        </v-toolbar>
        <v-card-title v-if="errorMsg" class="login__message">
          <strong>Error:</strong> <i>{{ errorMsg }}</i>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model.trim="userName"
              id="userName"
              name="userName"
              label="Email"
              type="text"
              required
              @input="$v.userName.$touch()"
              :color="validateUserName"></v-text-field>
            <v-text-field
              v-model.trim="password"
              id="password"
              name="password"
              label="Password"
              type="password"
              hint="At least 8 characters"
              min="8"
              required
              @input="$v.password.$touch()"
              :color="validatePassword"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn outline small color="primary" to="/forgot-password">Forgot Password</v-btn>
          <v-btn outline small color="primary" to="/">Login</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="$v.$invalid" :loading="isRegistering" @click="register">Register</v-btn>
        </v-card-actions>
      </v-card>

      <v-container>
        <v-btn to="/style-guide">View Style Guide</v-btn>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  data: () => {
    return {
      userName: undefined,
      errorMsg: undefined,
      isRegistering: false,
      password: undefined
    }
  },
  computed: {
    toolbarColor () {
      return !this.$v.$invalid && !this.errorMsg ? 'primary' : 'grey'
    },
    validateUserName () {
      return !this.$v.userName.$error ? 'primary' : 'red'
    },
    validatePassword () {
      return !this.$v.password.$error ? 'primary' : 'red'
    }
  },
  methods: {
    register () {
      if (this.$v.$invalid) {
        this.$v.userName.$touch()
        this.$v.password.$touch()
        return
      }

      let query = { userName: this.userName, password: this.password }
      this.errorMsg = undefined
      this.isRegistering = true
      this.$store.dispatch('user/register', query).then(res => {
        if (res.status === 200) {
          this.$store.dispatch('user/login', query).catch(() => {
            this.isRegistering = false
            this.errorMsg = 'There seems to be an unusual error. Please contact management to look into the issue. You may also try logging in because we believe you have been successfully registered.'
          })
        } else {
          this.isRegistering = false
          this.errorMsg = 'Something happened here. Please try logging into the system via the link below. If you are unsuccessful please contact management about the issue.'
        }
      }).catch(() => {
        this.isRegistering = false
        this.errorMsg = 'There seems to be a problem registering your account. If you believe you might have an account please use the login or forgot password link(s) below.'
      })
    }
  },
  validations: {
    userName: {
      required,
      email,
      minLength: minLength(3)
    },
    password: {
      required,
      minLength: minLength(8)
    }
  }
}
</script>

<style>

</style>
